/** Distingue Pago a cuenta (cliente) de Orden de Pago (proveedor). */

export function esPagoCuentaCliente(pago) {
  if (!pago) return false;
  return pago.cliente_id != null && pago.cliente_id !== '' && !pago.proveedor_id;
}

export function esMovimientoPagoCuenta(mov) {
  if (!mov) return false;
  if (mov.numero_pago_cuenta != null) return true;
  return Boolean(mov.pago_id && mov.cliente_id && !mov.proveedor_id);
}

export function numeroComprobantePago(pago) {
  if (!pago) return null;
  if (pago.numero != null) return pago.numero;
  return esPagoCuentaCliente(pago) ? pago.numero_pago_cuenta : pago.numero_pago;
}

export function tipoComprobantePago(pago) {
  if (pago?.tipo) return pago.tipo;
  return esPagoCuentaCliente(pago) ? 'Pago a cuenta' : 'Orden de pago';
}

export function etiquetaAnularPago(pago) {
  return esPagoCuentaCliente(pago) ? 'Anular pago a cuenta' : 'Anular orden de pago';
}

export function textoComprobanteEgreso(comp) {
  if (!comp) return '';
  const num = comp.numero ?? comp.numero_pago_cuenta ?? comp.numero_pago;
  const pref = comp.tipo === 'Pago a cuenta' ? 'Pago a cuenta' : 'OP';
  return num != null ? `${pref} N° ${num}` : comp.tipo || pref;
}
